if (!customElements.get('strava-form')) {
    class StravaForm extends HTMLElement {
        static observedAttributes = ["gtoken", "size"];

        dev = true;

        /* DynamoDB responses <-> status */
        dbRedponses = {
            "Email added correctly": true,
            "DynamoDB write failed": false,
            "Missing env"          : false,
            "Missing body"         : false,
            "Body Malformed"       : false,
            "Missing parameters"   : false
        };

        /* configs */
        k_public_api       = null;
        k_list_id          = null;
        contestName        = null;
        contestID          = null;
        lambda_url         = 'https://nuzgpb56cxfxpqudbfekd7ll6u0ayeqw.lambda-url.eu-south-1.on.aws/'; // lambda url for the API OLD: https://lk2wqokm44gescp42ebtzuals40fcxux.lambda-url.eu-south-1.on.aws/

        sentences          = null;

        /* Form data */
        token              = null;
        email              = null;
        profiling_accepted = false;

        /* html elements */
        button             = null;
        form               = null;
        email_input        = null;
        checkbox_inputs    = [];
        profiling_checkbox = null;
        message_container  = null;
        loader_container   = null;

        constructor() {
            super();

            this.button             = this.querySelector("button");
            this.form               = this.querySelector("form");
            this.email_input        = this.querySelector("#strava_email");
            this.checkbox_inputs    = this.querySelectorAll('input[type="checkbox"][required]');
            this.profiling_checkbox = this.querySelector('input#stava_second_check');
            this.message_container  = this.querySelector('[data-role="message"]');
            this.loader_container   = this.querySelector('[data-role="loader"]');
            this.message_button     = this.querySelector('[data-role="button-close"]');
            this.k_public_api       = this.getAttribute("data-kkey");
            this.k_list_id          = this.getAttribute("data-kseg");
            this.contestName        = this.getAttribute("data-cname");
            this.contestID          = this.getAttribute("data-cid");
            this.enableTimeout      = false;

            this.removeAttribute("data-kkey");
            this.removeAttribute("data-kseg");
            this.removeAttribute("data-cname");
            this.removeAttribute("data-cid");

            this.getConfig();
            this.hideLoader();
        }

        /* bind event to button */
        connectedCallback() {
            this.button?.addEventListener(
                "click",
                this.onSubmit.bind(this)
            );
            this.message_button?.addEventListener(
                "click",
                this.closeMessage.bind(this)
            );
        }

        /* Get sentences from shopify */
        getConfig(){
            this.#log("GET CONFIG");

            let config_container = this.querySelector('.config-script[type="application/json"]');
            if(config_container){
                this.sentences = JSON.parse(config_container.textContent);
            }

            this.#log('config:', this.sentences);
        }

        /*
            disconnectedCallback
                disconnectedCallback() {
                this.#log("StravaForm removed from page.");
            }

            adoptedCallback
                adoptedCallback() {
                this.#log("StravaForm moved to new page.");
            }
        */

        /* trigger when observed attribute changes */
        attributeChangedCallback(name, oldValue, newValue) {
            this.#log(`StravaForm attribute ${name} has changed.`);
            this.#log(`${name} old value: ${oldValue}.`);
            this.#log(`${name} new value: ${newValue}.`);

            if(name == "gtoken" && newValue){
                this.token = newValue;
                this.removeAttribute("gtoken");
                this.showLoader();
                this.writeToDynamoDB();
            }

            this.#log('gTOKEN:', this.token);
        }

        /* trigger submit pressed */
        onSubmit(event){
            event.preventDefault();

            this.#log('ON SUBMIT');

            if(!this.form.checkValidity()){
                this.#log('FORM INVALID');

                // Create the temporary button, click and remove it
                let tmpSubmit = document.createElement('button');
                this.form.appendChild(tmpSubmit);
                tmpSubmit.click();
                this.form.removeChild(tmpSubmit);
            }
            else{
                this.#log('FORM VALID');

                /* Get form values */
                this.email = this.email_input?.value;
                this.profiling_accepted = false;
                if(this.profiling_checkbox && this.profiling_checkbox.checked){
                    this.profiling_accepted = true;
                }

                this.#log('MAIL:', this.email);
                this.#log('Accepted profiling? ', this.profiling_accepted);

                grecaptcha.ready(function() {
                    grecaptcha.execute('6Ld37D0hAAAAADF_e4urFfDrhpmR1gRckf2YkyLv', {action: 'submit'})
                    .then(function(token) {
                        document.querySelector("strava-form")?.setAttribute("gtoken", token);
                    });
                });
            }
        }

        /* 1- if form valid then write to DB */
        writeToDynamoDB(){
            this.#log('WRITE TO DYNAMO');

            if(this.email &&
            this.token &&
            this.contestName &&
            this.contestID){
                const body = JSON.stringify(
                    {
                        'email'            : this.email,
                        'recaptchaResponse': this.token,
                        'contestName'      : this.contestName,
                        'contestID'        : this.contestID
                    }
                );

                this.#log('BODY:', body);

                fetch(this.lambda_url, {
                    method : 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: body
                })
                .then(response => {
                    this.status     = response.status;
                    this.statusText = response.statusText;
                    return response.json();
                })
                .then(result => {
                    this.result         = result;
                    this.result_message = result.message;
                    this.#log('STATUS:',         this.status);
                    this.#log('STATUS TEXT:',    this.statusText);
                    this.#log('RESULT:',         this.result);
                    this.#log('RESULT MESSAGE:', this.result_message);

                    if(this.checkDbStatus()){
                        this.#log('API OK:', this.result_message);
                        this.writeToKlaviyo();
                    }
                    else{
                        this.#log('API Error:', this.result_message);
                        this.errorHandler('API Error:' + this.result_message);
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    this.errorHandler(error);
                });

            }
            else{
                console.error('Error:', "missing email/contest name/contest id or failed recaptcha");
                this.errorHandler("missing email or failed recaptcha");
            }

        }

        /* 2- check write to DB */
        checkDbStatus(){
            this.#log('CHECK DB STATUS ON:', this.result_message, 'RESULT:', this.dbRedponses[this.result_message]);
            return this.dbRedponses[this.result_message];
        }

        /* 3- if write to DB ok then write to Klaviyo */
        writeToKlaviyo(){
            this.#log('WRITE TO Klaviyo');

            let attributes = null;

            if(this.profiling_accepted){
                attributes = {
                    email     : this.email,
                    properties: {
                        'Profile Consent': '["Profiling True"]'
                    }
                };
            }
            else{
                attributes = {
                    email     : this.email
                };
            }

            if(this.k_list_id && this.k_public_api){
                const options = {
                    method : 'POST',
                    headers: {
                        revision      : '2024-07-15',
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify({
                    data: {
                        type      : 'subscription',
                        attributes: {
                            profile: {
                                data: {
                                    type      : 'profile',
                                    attributes: attributes
                                }
                            }
                        },
                        relationships: {
                            list: {
                                data: {
                                    type: 'list',
                                    id  : this.k_list_id.toString()
                                }
                            }
                        }
                    }
                    })
                };
                const url = 'https://a.klaviyo.com/client/subscriptions?company_id=' + this.k_public_api;

                this.#log('URL:', url);
                this.#log('OPTIONS:', options);

                fetch(url, options)
                .then(response => {
                    this.#log("RESPONSE:", response);
                    this.k_status     = response.status;
                    this.k_statusText = response.statusText;
                    if(this.k_status != "202"){
                        return response.json();
                    }
                    else{
                        return { "status": "KK" };
                    }
                })
                .then(result => {
                    this.#log("RESULT:", result);
                    if(this.k_status == "202"){
                        this.outputMessage("Your registration was successful,<br>you will receive a confirmation email as soon as possible!<br><br>Good luck!");
                    }
                    else{
                        this.errorHandler(this.k_statusText);
                    }
                })
                .catch(err => {
                    console.error(err);
                    this.errorHandler(err);
                });

            }
            else{
                this.#log('Klaviyo settings are missing');
            }
        }

        /* 4- if write to Klaviyo ok then show message */
        outputMessage(message){
            this.#log('OUTPUT MESSAGE:', message);

            this.hideLoader();

            if(this.message_container){

                const title = this.message_container.querySelector(".message_title");
                const text  = this.message_container.querySelector(".message_text");

                this.classList.add("message_visible");
                this.message_container.classList.add("success");
                title.innerHTML = this.sentences.success.title.toString();
                text.innerHTML  = this.sentences.success.message.toString();
                if(this.enableTimeout){
                    setTimeout(() => {
                    this.classList.remove("message_visible");
                    this.message_container.classList.remove("success");
                    title.innerHTML = "";
                    text.innerHTML  = "";
                    this.hideLoader();
                }, 5000);
                this.resetForm();
                }
            }
        }

        /* if any error then show message */
        errorHandler(message){
            this.#log('ERROR MESSAGE:', message);

            this.hideLoader();

            if(this.message_container){
                const title = this.message_container.querySelector(".message_title");
                const text  = this.message_container.querySelector(".message_text");

                this.classList.add("message_visible");
                this.message_container.classList.add("error");
                title.innerHTML = this.sentences.error.title.toString() || "Oops!";
                text.innerHTML  = this.sentences.error.message.toString() || message;
                if(this.enableTimeout){
                setTimeout(() => {
                    this.classList.remove("message_visible");
                    this.message_container.classList.remove("error");
                    title.innerHTML = "";
                    text.innerHTML  = "";
                    this.hideLoader();
                }, 5000);
                this.resetForm();
                }
            }
        }

        closeMessage() {
            this.#log("CLOSE MESSAGE");

            this.classList.remove("message_visible");
            this.message_container.classList.remove("success", "error");

            const title = this.message_container.querySelector(".message_title");
            const text = this.message_container.querySelector(".message_text");
            if (title) title.innerHTML = "";
            if (text) text.innerHTML = "";
            this.resetForm();
        }

        /* e-mail input reset */
        resetEmailInput() {
            if (this.email_input) {
                this.email_input.value = "";
            }
        }
        resetCheckbox(){
            const allCheckboxes = this.querySelectorAll('input[type="checkbox"]');
            if (allCheckboxes.length > 0){
                allCheckboxes.forEach(allCheckbox => {
                    allCheckbox.checked = false;
                });
            }
        }
        /* form to BLANK status */
        resetForm(){
            this.#log('RESET FORM');
            this.resetEmailInput();
            this.resetCheckbox();
            this.hideLoader();
        }

        /* LOADER */
        showLoader(){
            this.#log('SHOW LOADER');

            this.button.disabled = true;
            if(this.loader_container){
                this.classList.add("loader_visible");
            }
        }
        hideLoader(){
            this.#log('HIDE LOADER');

            this.button.disabled = false;
            if(this.loader_container){
                this.classList.remove("loader_visible");
            }
        }

        /* UTILITY FUNCTIONS */
        #log() {
			if (this.dev) {
				console.log("[" + this.constructor.name + "]", ...arguments);
			}
		}
    }
    customElements.define("strava-form", StravaForm);
    //https://pedaled.com/pages/strava-test?view=stravachallenge

}
